import React, { useEffect, useRef } from "react";
import StoreFinder from "@src/stories/ecommerce/StoreFinder/StoreFinder";
import useLocationSearch from "@src/hooks/useLocationSearch";

const StoreSelectModal = ({ isOpen, onClose, onSelectStore, selectedStore }) => {
  const inputRef = useRef(null);
  const {
    stores: storeResults,
    searchByQuery,
    loading,
  } = useLocationSearch(inputRef);

useEffect(() => {
  if (isOpen) {
    window.scrollTo({ top: 0, behavior: "instant" });
    searchByQuery("");
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [isOpen]);

  return isOpen ? (
    <div className="relative z-20">
      <div className="fixed h-screen inset-0 bg-white lg:inset-auto lg:absolute lg:left-[90px] lg:top-full lg:h-[360px] lg:w-[474px] lg:rounded-none lg:border lg:border-[#BBBBBD] lg:shadow-[0px_4px_11px_0px_rgba(84,86,90,0.10)]">
        <button
          className="justify-end border-b p-4 border-[#ECEEEF] h-[58px] lg:hidden"
          onClick={() => {
            document.body.classList.remove("modal-open");
            onClose();
          }}
          aria-label="Close"
        >
          <i className="flex items-center icon icon-close-rounded"></i>
        </button>
        <div className="h-full p-4 overflow-y-auto bg-white lg:p-6">
          <div className="flex items-center justify-between mb-6">
            <h4 className="text-[#54565A] text-[21px]/6">Set My Store</h4>
          </div>
          {loading ? (
            <div className="text-center text-[#54565A] blabel py-6">Loading stores...</div>
          ) : (
            <>
              <StoreFinder
                inputRef={inputRef}
                layout="default"
                onSearch={searchByQuery}
              />
              {storeResults?.length > 0 && (
                <ul className="p-0 mt-6 space-y-3">
                  {storeResults.map((store) => (
                    <li
                      key={store.id}
                      onClick={() => {
                        onSelectStore(store);
                        onClose();
                      }}
                      className="flex items-center justify-between border-b border-[#ECEEEF] last:border-b-transparent cursor-pointer pb-3"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-5 h-5 border-2 border-[#23263B] rounded-full flex items-center justify-center">
                          {selectedStore?.id === store.id && (
                            <div className="w-2.5 h-2.5 bg-[#23263B] rounded-full"></div>
                          )}
                        </div>
                        <span className="font-normal text-black truncate b2">
                          {store.name}
                        </span>
                      </div>
                      {store.distance && (
                        <div className="blabel text-[#54565A] font-medium flex items-center">
                          {store.distance} km
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default StoreSelectModal;